import React from 'react';
import { Form } from 'react-bootstrap';
import Button from '../UI/button';
import { useAddTrip } from '../modals/trip/use-add-trip';

type AddTripFormProps = {
  label: string;
  placeholder?: string;
  submitTitle: string;
  onSuccess?: () => void;
};

const AddTripForm = ({
  label,
  placeholder,
  submitTitle,
  onSuccess
}: AddTripFormProps) => {
  const { trip, validated, handleInputChange, handleSubmit } =
    useAddTrip(onSuccess);

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group>
        <Form.Label>{label}</Form.Label>
        <Form.Control
          type='text'
          placeholder={placeholder}
          value={trip.title}
          onChange={(e) => handleInputChange('title', e.target.value)}
          required
        />
      </Form.Group>
      <Form.Group>
        <Form.Check
          type='checkbox'
          label='Auto-Organize'
          checked={trip.autoOrganize || false}
          onChange={(e) => handleInputChange('autoOrganize', e.target.checked)}
        />
      </Form.Group>
      <Button
        disabled={!validated}
        type='submit'
        width={167}
        className='mx-auto'
        style={{ marginTop: '24px' }}
      >
        {submitTitle}
      </Button>
    </Form>
  );
};

export default AddTripForm;
